import types from './types';

const INITIAL_STATE = {
  isFetchingNotes: false,
  isFetchingInfoForCarePlan: false,
  isFetchingCount: false,
  isFetchingNoteLogs: false,
  isFetchingStatus: false,
  isFetchingPlans: false,
  isFetchingPlanDetail: false,
  isFetchingMed: false,
  isFetchingSpecificPlan: false,
  isFetchingPlanLogs: false,
  isUpdating: false,
  isSavingNote: false,
  isSavingPlan: false,

  result: [],
};

const eligibilityPACReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_PAC_NOTES_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingNotes: true,
      };

    case types.GET_PAC_NOTES_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingNotes: false,
      };

    case types.GET_PAC_NOTES_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingNotes: false,
      };

    case types.GET_PAC_INFO_FOR_CARE_PLAN_PAGE_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingInfoForCarePlan: true,
      };

    case types.GET_PAC_INFO_FOR_CARE_PLAN_PAGE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingInfoForCarePlan: false,
      };

    case types.GET_PAC_INFO_FOR_CARE_PLAN_PAGE_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingInfoForCarePlan: false,
      };

    case types.GET_UNREAD_PAC_TYPE_COUNT_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingCount: true,
      };

    case types.GET_UNREAD_PAC_TYPE_COUNT_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingCount: false,
      };

    case types.GET_UNREAD_PAC_TYPE_COUNT_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingCount: false,
      };

    case types.GET_PAC_NOTE_LOGS_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingNoteLogs: true,
      };

    case types.GET_PAC_NOTE_LOGS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingNoteLogs: false,
      };

    case types.GET_PAC_NOTE_LOGS_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingNoteLogs: false,
      };

    case types.GET_PAC_STATUS_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingStatus: true,
      };

    case types.GET_PAC_STATUS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingStatus: false,
      };

    case types.GET_PAC_STATUS_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingStatus: false,
      };

    case types.GET_PAC_PLANS_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingPlans: true,
      };

    case types.GET_PAC_PLANS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingPlans: false,
      };

    case types.GET_PAC_PLANS_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingPlans: false,
      };

    case types.GET_PAC_DETAIL_PLAN_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingPlanDetail: true,
      };

    case types.GET_PAC_DETAIL_PLAN_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingPlanDetail: false,
      };

    case types.GET_PAC_DETAIL_PLAN_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingPlanDetail: false,
      };

    case types.GET_PAC_MED_DETAIL_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingMed: true,
      };

    case types.GET_PAC_MED_DETAIL_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingMed: false,
      };

    case types.GET_PAC_MED_DETAIL_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingMed: false,
      };

    case types.GET_PAC_PLAN_LOGS_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingPlanLogs: true,
      };

    case types.GET_PAC_PLAN_LOGS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingPlanLogs: false,
      };

    case types.GET_PAC_PLAN_LOGS_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingPlanLogs: false,
      };

    case types.UPDATE_PAC_READ_INFO_REQUEST:
      return {
        ...state,
        result: [],
        isUpdating: true,
      };

    case types.UPDATE_PAC_READ_INFO_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isUpdating: false,
      };

    case types.UPDATE_PAC_READ_INFO_FAILURE:
      return {
        ...state,
        result: [],
        isUpdating: false,
      };

    case types.SAVE_PAC_NOTE_REQUEST:
      return {
        ...state,
        result: [],
        isSavingNote: true,
      };

    case types.SAVE_PAC_NOTE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isSavingNote: false,
      };

    case types.SAVE_PAC_NOTE_FAILURE:
      return {
        ...state,
        result: [],
        isSavingNote: false,
      };

    case types.SAVE_PAC_PLAN_REQUEST:
      return {
        ...state,
        result: [],
        isSavingPlan: true,
      };

    case types.SAVE_PAC_PLAN_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isSavingPlan: false,
      };

    case types.SAVE_PAC_PLAN_FAILURE:
      return {
        ...state,
        result: [],
        isSavingPlan: false,
      };

    default:
      return state;
  }
};

export default eligibilityPACReducer;
